'use client'

import { useEffect } from 'react'

import { hideZohoSalesIq, showZohoSalesIq } from '@/src/utils/zohoSalesIq'

/**
 * Zoho SalesIQ chat widget for the trips and contact pages.
 * Renders nothing. Mirrors the GlobalClientEffect single-file client-effect pattern.
 */
export default function ZohoSalesIq() {
    useEffect(() => {
        showZohoSalesIq()
        return hideZohoSalesIq
    }, [])

    return null
}
